// use-isomorphic-layout-effect.js
// see https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a for more info

import { useLayoutEffect, useEffect } from 'react'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
export default useIsomorphicLayoutEffect
